<!-- <div class="page">
  <div class="title">
    <h3 class="page-title">{{ 'adjuster.dashboard' | translate }}</h3>
  </div>
</div> -->
<router-outlet></router-outlet>